// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__14Csk","list":"styles_list__JTv76"};